import axiosInstance from '../../services/axios';
import { applyFilters, getAPIEndpoint } from '../../helpers'


export default {
    namespaced: true,
    state: {

    },
    getters: {




    },
    actions: {

        sendNotification({ state, commit }, notificationData) {

            const url = `${getAPIEndpoint()}/notifications/send`

            return axiosInstance.post(url, notificationData).then(res => {




                // commit('setDashboard', dashboardData);
                // const response = res.data.data.data

                // commit('loadProducts', productArray)


            })


        }




    },
    mutations: {

    }
}